import { PropsWithChildren } from "react";

import { AppBridgeContext, AppBridgeContextValue } from "@/contexts/AppBridgeContext";

type AppBridgeProviderProps = PropsWithChildren<AppBridgeContextValue>;

export function AppBridgeProvider({ children, ...routeProps }: AppBridgeProviderProps) {
  return <AppBridgeContext.Provider value={routeProps}>{children}</AppBridgeContext.Provider>;
}
